import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Loader } from '@/components/loaders/Loader'
import { BasicModal } from '@/components/layout/modals/BasicModal'
import { Button } from '@/components/buttons/Button'
import { CopyButton } from '@/components/buttons/CopyButton'
import { fetchYaml } from '@/reducers/voiceAgents/voiceAgents.actions'

// YAML modal for the workspace header. Loads `prompt_config.yaml` on first
// open via the existing fetchYaml thunk and caches it in the slice.
// POC runs against the mock adapter — real BE wire-up requires response-type
// handling for `text/yaml` per the open question in
// web/.local/open-questions-for-luka.md.
const YamlModal = ({ show, onClose }) => {
  const dispatch = useDispatch()
  const agentId = useSelector((state) => state.voiceAgents.selectedAgentId)
  const yaml = useSelector((state) =>
    agentId ? state.voiceAgents.yamlByAgentId[agentId] || '' : ''
  )
  const loading = useSelector((state) => Boolean(state.voiceAgents.loading.yaml))

  useEffect(() => {
    if (show && agentId && !yaml) {
      dispatch(fetchYaml(agentId))
    }
  }, [show, agentId, yaml, dispatch])

  return (
    <BasicModal
      title={agentId ? `Prompt config YAML — ${agentId}` : 'Prompt config YAML'}
      show={show}
      onClose={onClose}
      size="large"
      scrolling
      footer={
        <div className="voice-agents__yaml-modal-footer">
          <CopyButton content={yaml} name="YAML" data-testid="yaml-copy-button" />
          <Button basic onClick={onClose} data-testid="yaml-close-button">
            Close
          </Button>
        </div>
      }
    >
      {loading ? (
        <Loader centered label="Loading YAML…" />
      ) : (
        <pre className="voice-agents__yaml-body" data-testid="yaml-modal-body">
          {yaml || 'No YAML available.'}
        </pre>
      )}
    </BasicModal>
  )
}

export default YamlModal
